<template>
    <div class="page search-list">
        <div class="search">
            <van-search ref="search_input" v-model="value" :autofocus="autofocus" show-action @search="onSearch" @cancel="onCancel" placeholder="搜一搜">
                <template slot="action">
                    <div class="search-list-action" @click="onSearch">搜索</div>
                </template>
            </van-search>
        </div>

        <div class="tags" v-if="(course.length + live.length + article.length + short_video.length) > 0">
            <van-tabs v-model="category_index" @click="onSearch" swipeable>
                <van-tab :title-class="'course-list-category-title'" v-for="(item,index) in categories" :key="item.id" :title="item.name" :disabled="item.name==''" />
            </van-tabs>
            <div class="clear"></div>
        </div>

        <div v-if="live.length > 0" class="search-list-section">
            <div class="search-list-title">相关直播<span @click="$router.push({name:'live-list'})">查看更多<img src="/static/img/icon_more.svg" alt=""></span></div>
            <div class="live-list-section">
                <van-row @click="go_live_detail(item)" v-for="item in live" :key="item.id">
                    <div class="live-list-section-box">
                        <div class="live-list-section-left">
                            <img class="live-list-section-left-img" :src="item.cover_img">

                            <div v-if="item.live_status==0" class="live-list-section-left-zl">直播预告</div>
                            <div v-else-if="item.live_status==1" class="activity-list-section-right-tags current">
                                <img src="/static/bytx/activity_list_live_icon.gif" alt=""> {{item.status_text}}
                            </div>
                            <div v-else class="live-list-section-left-zl">直播回放</div>
                            <div class="live-list-section-left-time" v-if="item.live_status>1"><span>{{item.duration_format}}</span></div>
                        </div>
                        <div class="live-list-section-right">
                            <div class="live-list-section-right-title" v-html="item.title"></div>
                            <div class="live-list-section-right-detail">
                                <span v-if="item.type === 2">{{item.live_desc}}</span>
                                <span v-else-if="item.live_status < 2">{{item.start_at}}</span>
                                <span v-else>{{item.view_count}}人观看</span>
                                <span class="live-list-section-right-detail-join"
                                      v-if="item.type === 1 && item.live_status===0">预约</span>
                                <span class="live-list-section-right-detail-join"
                                      v-else-if="item.type === 1 && item.live_status===1">加入</span>
                            </div>
                        </div>
                    </div>
                </van-row>
            </div>
        </div>

        <div v-if="(activities.length + guides.length + clinics.length + communities.length + knowledge.length + comrades.length + diagnoses.length) > 0" class="search-list-section">
            <div class="search-list-title">相关图文</div>
            <div v-if="activities.length > 0" class="activity-list-section" style="padding-bottom: 0">
                <van-row class="activity-list-section-box" @click="go_active_detail(item)" v-for="item in activities" :key="item.id">
                    <div class="activity-list-section-left">
                        <van-image
                            fit="cover"
                            class="activity-list-section-left-img"
                            :src="item.cover_img"
                            width="100%"
                            height="100%"
                        />
                        <div class="activity-list-section-left-zl">
                            {{item.type_text}}
                        </div>
                    </div>
                    <div class="activity-list-section-right">
                        <div v-if="item.status_text === '进行中'" class="activity-list-section-right-tags active">{{item.status_text}}</div>
                        <div v-else-if="item.status_text === '直播中'" class="activity-list-section-right-tags current">
                            <img src="/static/bytx/activity_list_live_icon.gif" alt=""> {{item.status_text}}
                        </div>
                        <div v-else-if="item.status_text === '已结束'" class="activity-list-section-right-tags end">
                            <img src="/static/bytx/activity_list_done_icon.svg" alt=""> {{item.status_text}}
                        </div>
                        <div v-else-if="item.status_text === '未开始'" class="activity-list-section-right-tags end">
                            <img src="/static/bytx/activity_list_done_icon.svg" alt=""> {{item.status_text}}
                        </div>
                        <div v-else-if="item.status_text === '预告'" class="activity-list-section-right-tags appoint">
                            <img src="/static/bytx/activity_list_preview_icon.svg" alt=""> {{item.status_text}}
                        </div>
                        <div v-else-if="item.status_text === '已预约'" class="activity-list-section-right-tags appoint">
                            <img src="/static/bytx/activity_list_preview_icon.svg" alt=""> {{item.status_text}}
                        </div>
                        <div class="activity-list-section-right-time">{{item.start_at}}</div>
                        <div class="activity-list-section-right-title" v-html="item.title"></div>
                    </div>
                    <div class="clear"></div>
                </van-row>
            </div>
            <div v-if="guides.length > 0" class="guide-list-section" style="padding-bottom: 0">
                <van-row class="guide-list-section-box" v-for="item in guides" :key="item.id" @click="$router.push({name:'guide-detail',params:{id:item.id}})">
                    <div class="guide-list-section-left">
                        <van-image
                            fit="cover"
                            class="guide-list-section-left-img"
                            :src="item.cover_img"
                            width="100%"
                            height="100%"
                        />
                        <div class="guide-list-section-left-zl">
                            就诊指南
                        </div>
                    </div>
                    <div class="guide-list-section-right">
                        <div class="guide-list-section-right-title" v-html="item.title"></div>
                        <div class="guide-list-section-right-detail">
                            <div>
                                {{item.created_at}}
                                <span style="margin-left: 8px">{{item.view_count}}人阅读</span>
                            </div>
                        </div>
                    </div>
                </van-row>
                <div class="clear"></div>
            </div>
            <div v-if="clinics.length > 0" class="clinic-list-section" style="padding-bottom: 0">
                <van-row class="clinic-list-section-box" style="padding-bottom: 0" v-for="item in clinics" :key="item.id" @click="$router.push({name:'clinic-detail',params:{'id':item.id}})">
                    <div class="clinic-list-title" v-html="'<span>临床招募</span>'+item.title"></div>
                    <div class="clinic-list-desc">
                        {{item.desc.length > 26 ? item.desc.substr(0,26)+'...' : item.desc}}
                    </div>
                    <div class="clinic-list-tags">
                        <span v-for="val in item.tags.split(',')">#{{val}}</span>
                    </div>
                </van-row>
            </div>
            <div v-if="communities.length > 0" class="community-list-section">
                <van-row class="community-list-section-box" v-for="item in communities" :key="item.id" @click="$router.push({name : 'community-detail',params : {id : item.id}})">
                    <div class="community-list-section-left">
                        <van-image
                            fit="cover"
                            class="community-list-section-left-img"
                            :src="item.cover_img"
                            width="100%"
                            height="100%"
                        />
                        <div class="community-list-section-left-zl">
                            公益活动
                        </div>
                    </div>
                    <div class="community-list-section-right">
                        <div class="community-list-section-right-title" v-html="item.title"></div>
                        <div class="community-list-section-right-detail">
                            <div>
                                {{item.created_at}}
                                <span style="margin-left: 8px">{{item.view_count}}人阅读</span>
                            </div>
                        </div>
                    </div>
                    <div class="clear"></div>
                </van-row>
            </div>
            <div v-if="knowledge.length > 0" class="knowledge-list-sidebar-section" style="height: inherit">
                <van-list class="knowledge-list-sidebar-section-box">
                    <van-cell is-link class="knowledge-list-sidebar-section-title" v-for="item in knowledge" @click="$router.push({name:'knowledge-list',params:{'id':item.id}})" :key="item.id">
                        <template slot="title">
                            <span v-html="item.title"></span>
                        </template>
                    </van-cell>
                </van-list>
            </div>
            <div v-if="comrades.length > 0" class="comrade-list-section">
                <van-row v-for="item in comrades" :key="item.id" @click="$router.push({name:'comrade-detail',params:{id:item.id}})">
                    <div v-if="item.type===1" class="comrade-list-section-box">
                        <div class="comrade-list-section-left">
                            <van-image
                                fit="cover"
                                class="comrade-list-section-left-img"
                                :src="item.cover_img"
                                width="100%"
                                height="100%"
                            />
                            <div class="comrade-list-section-left-zl">
                                战友故事
                            </div>
                        </div>
                        <div class="comrade-list-section-right">
                            <div class="comrade-list-section-right-title" v-html="item.title"></div>
                        </div>
                        <div class="clear"></div>
                        <div class="comrade-list-section-stats">
                            <img src="/static/bytx/companion_list_read_icon.svg" alt=""> <span>{{item.view_count}}</span>
                            <img src="/static/bytx/companion_list_helpful_icon.svg" alt=""> <span>{{item.comment_count}}</span>
                            <img src="/static/bytx/companion_list_comment_icon.svg" alt=""> <span>{{item.like_count}}</span>
                        </div>
                        <div class="clear"></div>
                    </div>
                    <div class="comrade-list-section-box" v-else>
                        <div class="comrade-list-section-title">{{item.title}}</div>
                        <van-image
                            fit="cover"
                            class="comrade-list-section-left-img"
                            :src="item.cover_img"
                            width="100%"
                            height="100%"
                        />
                        <div class="comrade-list-section-left-zl">
                            {{item.type_text}}
                        </div>
                        <img class="comrade-list-section-play-btn" src="/static/bytx/list_video_play_2.svg" alt="">
                        <div class="comrade-list-section-stats">
                            <img src="/static/bytx/companion_list_read_icon.svg" alt=""> <span>{{item.view_count}}</span>
                            <img src="/static/bytx/companion_list_helpful_icon.svg" alt=""> <span>{{item.comment_count}}</span>
                            <img src="/static/bytx/companion_list_comment_icon.svg" alt=""> <span>{{item.like_count}}</span>
                        </div>
                        <div class="clear"></div>
                    </div>
                </van-row>
            </div>
            <div v-if="diagnoses.length > 0" class="diagnose-list-section">
                <van-row class="diagnose-list-section-box" v-for="item in diagnoses" :key="item.id" @click="$router.push({name:'diagnose-detail',params:{id:item.id},})">
                    <div class="diagnose-list-section-left">
                        <van-image
                            fit="cover"
                            class="diagnose-list-section-left-img"
                            :src="item.cover_img"
                            width="100%"
                            height="100%"
                        />
                        <div class="diagnose-list-section-left-zl">
                            {{item.type_text}}
                        </div>
                    </div>
                    <div class="diagnose-list-section-right">
                        <div class="diagnose-list-section-right-title">{{item.title}}</div>
                        <div class="diagnose-list-section-right-btn">去查看 <img src="/static/bytx/list_more_icon.svg" alt=""></div>
                    </div>
                    <div class="clear"></div>
                    <div class="diagnose-list-section-info">{{item.desc}}</div>
                </van-row>
            </div>
        </div>

        <van-empty v-if="empty" description="" image="/static/img/pic_blank_content.svg">
            <template slot="description">
                <!--<div style="text-align: center">已到底部</div>-->
                <div style="text-align: center">博医同行持续更新中…</div>
                <div style="text-align: center;margin-top: 10px">先看看其他内容吧！</div>
                <div style="text-align: center;margin-top: 24px">
                    <van-button color="#0FB7AD" round size="small" style="width: 120px" @click="$toHomePage">
                        返回首页
                    </van-button>
                </div>
            </template>
        </van-empty>
    </div>
</template>
<script>
import Interface from "@/util/interface"

export default {
    name: 'search-list',
    data() {
        return {
            value: "",
            active: "",
            category_id: 0,
            category_child_id: 0,
            banners: [],
            category_index:0,
            autofocus:false,
            categories: [
                {
                    id:1,
                    name:"综合"
                },
                {
                    id:2,
                    name:"按时间"
                },
                {
                    id:3,
                    name:"按热度"
                },
                {
                    id:4,
                    name:""
                },
                {
                    id:5,
                    name:""
                },
            ],
            categories_child: [],

            course: [],
            short_video: [],
            live: [],
            article: [],
            activities:[],
            guides:[],
            clinics:[],
            communities:[],
            knowledge:[],
            comrades:[],
            diagnoses:[],


            empty: false,
            order:0,
        }
    },
    methods: {
        onCancel() {
            this.short_video = [];
            this.course = [];
            this.live = [];
            this.article = [];
            this.activities = [];
            this.clinics = [];
            this.communities = [];
            this.comrades = [];
            this.diagnoses = [];
        },
        onSearch() {
            let params = {
                keyword: this.value,
                order:this.category_index,
                from:this.$route.query.from,
            }
            Interface.getData('get', Interface.search, params).then((res) => {
                if (res.data.videos != null) {
                    this.short_video = res.data.videos
                } else {
                    this.short_video = []
                }
                if (res.data.articles != null) {
                    this.article = res.data.articles
                } else {
                    this.article = []
                }
                if (res.data.courses != null) {
                    this.course = res.data.courses
                } else {
                    this.course = []
                }
                if (res.data.lives != null) {
                    this.live = res.data.lives
                } else {
                    this.live = []
                }
                if (res.data.activities != null) {
                    this.activities = res.data.activities
                } else {
                    this.activities = []
                }
                if (res.data.guides != null) {
                    this.guides = res.data.guides
                } else {
                    this.guides = []
                }
                if (res.data.clinics != null) {
                    this.clinics = res.data.clinics
                } else {
                    this.clinics = []
                }
                if (res.data.communities != null) {
                    this.communities = res.data.communities
                } else {
                    this.communities = []
                }
                if (res.data.knowledge != null) {
                    this.knowledge = res.data.knowledge
                } else {
                    this.knowledge = []
                }
                if (res.data.comrades != null) {
                    this.comrades = res.data.comrades
                } else {
                    this.comrades = []
                }
                if (res.data.diagnoses != null) {
                    this.diagnoses = res.data.diagnoses
                } else {
                    this.diagnoses = []
                }

                if (res.data.videos == null && res.data.articles == null && res.data.courses == null && res.data.lives == null) {
                    this.empty = true
                } else {
                    this.empty = false
                }
            })
            sessionStorage.setItem("search_data",this.value)
        },
        go_detail(item) {
            if (item.type != 2) {
                this.$router.push({'name': 'course-detail', params: {id: item.id}})
            } else {
                this.$router.push({'name': 'course-column', params: {id: item.id}})
            }
        },
        go_live_detail(item) {
            if (item.type === 2) {
                this.$router.push({'name': 'live-column', params: {id: item.id}})
            } else if (item.live_status === 6) {
                this.$router.push({'name': 'live-detail-home', params: {id: item.id}})
            } else {
                if (item.live_status === 0) {
                    this.$router.push({'name': 'live-detail', params: {id: item.id}})
                } else {
                    this.$router.push({'name': 'live-detail-home', params: {id: item.id}})
                }
            }
        },
        go_active_detail(item){
            if (item.live_id > 0){
                this.$router.push({
                    name : 'live-detail',
                    params : {id : item.live_id}
                })
            }else{
                this.$router.push({
                    name: 'activity-detail',
                    params: {id: item.id}
                })
            }
        }
    },
    created() {
        Interface.getShareInfo(this,"","","")
        let search_data = sessionStorage.getItem("search_data")
        if (search_data != null){
            this.value = search_data
            this.onSearch()
        }else{
            this.autofocus = true
        }
    }
}
</script>
<style lang="scss">
@import "./index";
</style>



// WEBPACK FOOTER //
// src/views/search-more/index.vue